// extracted by mini-css-extract-plugin
export default {"container":"Domains_container__kBJ0-"};